const omitTypename = <T>(object: T): T => {
  const omitTypenameReplacer = (key: string, value: unknown) =>
    key === '__typename' ? undefined : value;
  return JSON.parse(JSON.stringify(object), omitTypenameReplacer) as T;
};

export default omitTypename;
